module.exports = __webpack_public_path__ + "static/media/renren.8dbd0712.svg";